/* eslint-disable  react/require-default-props */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BridgecrestInformation from './bridgecrest-information/BridgecrestInformation';
import {
  BankInformationWrapper,
  BridgecrestInformationWrapper,
  BankInformationTitle,
  BankInformationDetailsWrapper,
  BankInformationDetails,
  BankInformationValue,
  BankInformationDetailsContainer,
  BankInformationAccountNumberText,
  BankInformationBankText,
  BankInformationBankTextDivider,
  BankInformationBankTextWrapper,
  BankInformationCardLabel,
  BankInformationDetailsRight,
} from './BankInformation.styles';
import UpdateBankWarningDialog from '../future-packages/update-bank-dialog';
import { useDualEventTracking } from '../../utils/useDualEventTracking';
import {
  getMyOnetimePaymentSchedules,
  getPaymentEligiblity,
} from '../../ducks/selectors';

const BankInformation = (props: {
  vehicleId: any;
  bankAccounts: any[];
  updateBankTrackEvent: string;
  isPaidInFull: boolean;
  isHalfView?: boolean;
}) => {
  const [openUpdateBankDetailsModal, setOpenUpdateBankDetailsModal] = useState(
    false
  );
  const paymentEligibility = useSelector(getPaymentEligiblity);
  const oneTimePayments = useSelector(getMyOnetimePaymentSchedules);

  const {
    bankAccounts: { ...bankAccounts },
    vehicleId,
    updateBankTrackEvent,
    isPaidInFull,
    isHalfView,
  } = props;
  const { trackEvent } = useDualEventTracking();

  const onUpdateBankInfoClick = (e: any) => {
    trackEvent(updateBankTrackEvent);
    if (!updateBankInfoEligible()) {
      e.preventDefault();
      trackEvent('update_bank_scheduled_payments_dialogue');
      setOpenUpdateBankDetailsModal(!openUpdateBankDetailsModal);
    }
  };

  const toggleUpdateBankDetailsModal = () => {
    setOpenUpdateBankDetailsModal(!openUpdateBankDetailsModal);
  };

  const updateBankInfoEligible = () =>
    !paymentEligibility?.recurringPaymentEligibility?.isEnrolled &&
    !hasUpcomingOneTimePayment();

  const hasUpcomingOneTimePayment = () =>
    oneTimePayments?.some((payment: any) => {
      const currentDate = new Date();
      const paymentDate = new Date(payment.paymentDate);
      return !payment.isRecurring && paymentDate >= currentDate;
    });

  const bankAccount = bankAccounts[0];
  const paidOffClass = isPaidInFull ? 'paidOffLoan' : 'activeLoan';
  return (
    <>
      <BankInformationWrapper className={paidOffClass} isHalfView={isHalfView}>
        {bankAccount && (
          <BankInformationDetailsWrapper>
            <BankInformationCardLabel>
              Bank Information
            </BankInformationCardLabel>

            <BankInformationDetailsContainer isHalfView={isHalfView}>
              <BankInformationDetails>
                <div>
                  <BankInformationTitle>
                    {bankAccount.paymentMethodNickName}
                  </BankInformationTitle>
                </div>
                <BankInformationBankTextWrapper>
                  <BankInformationBankText>Bank</BankInformationBankText>
                  <BankInformationBankTextDivider>
                    |
                  </BankInformationBankTextDivider>
                  <Link
                    to={`/loan-detail/connect-bank/${vehicleId}`}
                    onClick={onUpdateBankInfoClick}
                  >
                    Update Bank Details
                  </Link>
                </BankInformationBankTextWrapper>
              </BankInformationDetails>
              <BankInformationDetails>
                <BankInformationDetailsRight>
                  <div>
                    <BankInformationValue>
                      ...{bankAccount.last4OfPaymentMethod}
                    </BankInformationValue>
                  </div>
                  <BankInformationAccountNumberText>
                    Account Number
                  </BankInformationAccountNumberText>
                </BankInformationDetailsRight>
              </BankInformationDetails>
            </BankInformationDetailsContainer>
          </BankInformationDetailsWrapper>
        )}

        <BridgecrestInformationWrapper>
          <BridgecrestInformation />
        </BridgecrestInformationWrapper>
      </BankInformationWrapper>
      <UpdateBankWarningDialog
        openModal={openUpdateBankDetailsModal}
        toggleModal={toggleUpdateBankDetailsModal}
      />
    </>
  );
};

export default BankInformation;
